// This file was automatically generated from print.imagingOrder.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.imagingOrder');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');
goog.require('el8.template.print.order');
goog.require('el8.template.print');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.imagingOrder.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  el8.template.print.headerInfoOrders(opt_data, output);
  output.append('<div class="orderDetailsContainer preserve"><table class="w100"><tr><td class="pr10">');
  el8.template.print.order.testsSection(opt_data, output);
  el8.template.print.order.section({title: 'Reason for Exam', text: opt_data.order.clinicalReason}, output);
  el8.template.print.order.section({title: 'Notes/Instructions to Center', text: opt_data.order.testCenterNotes}, output);
  el8.template.print.order.ccsSection(opt_data, output);
  el8.template.print.order.section({title: 'Note to Patient', text: opt_data.order.patientInstructions}, output);
  output.append('</td><td class="rightColumn">');
  el8.template.print.order.dxsSectionBullets(opt_data, output);
  output.append('</td></tr></table></div>');
  el8.template.print.signature({esignatureUrl: opt_data.order.esignatureUrl, isOrder: true, localFsPath: opt_data.localFsPath, signPhysician: opt_data.order.signPhysician, signPhysicianIdentifiers: opt_data.order.signPhysicianIdentifiers, signDate: opt_data.order.signDate}, output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};
